<template>
    <div class="margin-40-60-0 ticket">
        <div>
            <el-page-header @back="close" content="打印准考证"></el-page-header>
        </div>
        <div style="text-align: right;margin: auto;margin-right: 200px">
            <el-button type="primary" @click="downloadResult('mainContent')">导出图片准考证</el-button>
            <el-button type="primary" @click="printOutpdf('mainContent')">导出PDF准考证</el-button>
            <!--            <el-button type="primary" @click="exportWord">导出word准考证</el-button>-->
<!--            <el-button type="primary" v-print="'#mainContent'">打印准考证</el-button>-->
<!--            <el-button type="primary" @click="handlePrint">打印</el-button>-->
<!--            <el-button ref="printBtn" v-show="false" type="primary" v-print="printObj">打印</el-button>-->

        </div>
        <div class="page" id="mainContent" :style="{backgroundImage:(showBa ?`url(${orgBackground})`:'')}">
            <div style="height: 60px;margin-top: -30px;text-align: center">
                <h2>{{new Date().getFullYear()}}年湖北省普通高等学校专升本考试考生准考证</h2>
            </div>
            <div style="width: 100%;height: auto;color: #000!important;">
                <div style="width: 100%;height: 180px">
                    <div style="width: 80%;float: left;text-align: left">
                        <div class="titleTicket">
                            <span class="titleSpan" style="">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
                            <span style="margin-left: 50px;font-size: 20px">{{ticketForm.name}}</span>
                        </div>
                        <div class="titleTicket">
                            <span class="titleSpan">准考证号：</span>
                            <span style="margin-left: 50px;font-size: 20px">{{ticketForm.ticketNumber}}</span>
                        </div>
                        <div class="titleTicket">
                            <span class="titleSpan">身份证号：</span>
                            <span style="margin-left: 50px;font-size: 20px">{{ticketForm.idCard}}</span>
                        </div>
                    </div>
                    <div style="width: 20%;float: left;">
                        <img style="width: 140px; height: 160px;margin-top: 20px" id="faceImg" src=""/>
                    </div>
                </div>
                <table width="100%" border="1" class="table-edit" style="color: #000;font-size: 18px" cellspacing="0" cellpadding="0"  align="center">
                    <tr>
                        <th>考点名称</th>
                        <td colspan="4" style="text-align: left;">武汉晴川学院</td>
                    </tr>
                    <tr>
                        <th>考点地址</th>
                        <td colspan="4" style="text-align: left;">武汉市东湖新技术开发区中华科技产业园玉屏大道9号</td>
                    </tr>
                    <tr>
                        <th>考试日期</th>
                        <th>考试时间</th>
                        <th style="width: 100px">考试科目</th>
                        <th>考场号</th>
                        <th>座位号</th>
                    </tr>
                    <tr v-for="item in ticketForm.majorItemList">
                        <td>{{item.examDay}}</td>
                        <td>{{item.examStartTime}}~{{item.examEndTime}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.examRoomNum}}</td>
                        <td>{{item.seatNumber}}</td>
                    </tr>
                </table>
            </div>
            <div style="text-align: left;text-indent: 20px;color: #000!important;" v-if="ticketForm && ticketForm.sysMajor" v-html="ticketForm.sysMajor.xz">
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import fileDownload from "js-file-download";
import noData from '@/components/noData/noData';
import html2canvas from 'html2canvas';
import Watermark from '@/util/waterMark';
import JsPDF from 'jspdf'
let loading;
export default {
    name: "sysStudentTicket",
    components: { noData },
    props:["title","id"],
    data() {
        return {
            ticketForm: {
                faceImg:'',
            },
            config:config,
            ticketTime:'',
            checkTime:'',
            orgBackground: "",
            showBa:true,
            printObj: {
                id: "mainContent",
                closeCallback:()=>{
                    this.showBa=true   // 取消或者打印成功，返回页面时不显示水印
                    console.log(this.showBa)
                }
            },
        }
    },
    created(){
        axios({
            url:`${home}/login/checkTicketTime`,
            method:'GET'
        }).then(res=>{
            this.submit();
        }).catch(error=>{

        })
        this.orgBackground = Watermark.addWaterMark();
    },
    mounted(){

    },
    methods: {
        handlePrint(){
            this.showBa=true
            this.$refs.printBtn.$el.click()
        },
        submit(){
            axios({
                url:`${home}/sysStudent/getTicketById/${this.id}`,
                method:'GET',
            }).then(res=>{
                this.ticketForm=res.data;
                this.getUrlBase64(config.resPre+res.data.faceImg, "jpg", function (base64) {
                    document.getElementById("faceImg").src = base64;
                });

            }).catch(function (error) {
                console.log(error);
            });
        },
        dataURLToBlob(dataurl) {//ie 图片转格式
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type: mime})
        },
        downloadResult(name) {
            loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let canvasID = document.getElementById(name);
            let a = document.createElement('a');
            let opts = {
                scale: 3, // 添加的scale 参数
                logging: false, //日志开关，便于查看html2canvas的内部执行流程
                useCORS: true, // 【重要】开启跨域配置
            };
            html2canvas(canvasID,opts).then(canvas => {
                let dom = document.body.appendChild(canvas);
                dom.style.display = "none";
                a.style.display = "none";
                document.body.removeChild(dom);
                let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
                a.setAttribute("href", URL.createObjectURL(blob));
                a.setAttribute("download", this.ticketForm.name + "的准考证.png")
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(blob);
                document.body.removeChild(a);
                loading.close();
            });
        },
        /**
         *
         * @param url 图片路径
         * @param ext 图片格式
         * @param callback 结果回调
         */
        getUrlBase64(url, ext, callback) {
            var canvas = document.createElement("canvas");   //创建canvas DOM元素
            var ctx = canvas.getContext("2d");
            var img = new Image;
            img.crossOrigin = 'Anonymous';
            img.src = url;
            img.onload = function () {
                canvas.height = 140; //指定画板的高度,自定义
                canvas.width = 150; //指定画板的宽度，自定义
                ctx.drawImage(img, 0, 0, 140, 150); //参数可自定义
                var dataURL = canvas.toDataURL("image/" + ext);
                callback.call(this, dataURL); //回掉函数获取Base64编码
                canvas = null;
            };

        },
        printOut(name) {
            // 个人观察只是截取可见范围以及以下的区域，所以先将滚动条置顶
            $(window).scrollTop(0); // jQuery 的方法
            document.body.scrollTop = 0; // IE的
            document.documentElement.scrollTop = 0; // 其他
            this.downloadResult(name)
        },
        printOutpdf(name) {
            loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let shareContent = document.getElementById(name),//需要截图的包裹的（原生的）DOM 对象
                width = shareContent.clientWidth, //获取dom 宽度
                height = shareContent.clientHeight, //获取dom 高度
                canvas = document.createElement("canvas"), //创建一个canvas节点
                scale = 3; //定义任意放大倍数 支持小数
            canvas.width = width * scale; //定义canvas 宽度 * 缩放
            canvas.height = height * scale; //定义canvas高度 *缩放
            canvas.style.width = shareContent.clientWidth * scale + "px";
            canvas.style.height = shareContent.clientHeight * scale + "px";
            canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
            let opts = {
                scale: scale, // 添加的scale 参数
                logging: false, //日志开关，便于查看html2canvas的内部执行流程
                useCORS: true, // 【重要】开启跨域配置
            };
            html2canvas(shareContent,opts).then(canvas => {
                var contentWidth = canvas.width;
                var contentHeight = canvas.height;
                //一页pdf显示html页面生成的canvas高度;
                var pageHeight = (contentWidth / 592.28) * 841.89;
                //未生成pdf的html页面高度
                var leftHeight = contentHeight;
                //页面偏移
                var position = 0;
                //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                var imgWidth = 595.28;
                var imgHeight = 841.89;
                var pageData = canvas.toDataURL("image/jpeg", 1.0);
                var PDF = new JsPDF("", "pt", "a4");
                if (leftHeight < pageHeight) {
                    PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                } else {
                    while (leftHeight > 0) {
                        PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                        leftHeight -= pageHeight;
                        position -= 841.89;
                        if (leftHeight > 0) {
                            PDF.addPage();
                        }
                    }
                }
                PDF.save(this.ticketForm.name + "的准考证.pdf"); // 这里是导出的文件名
                loading.close();
            });
        },
        close(){
            this.$emit('closeSysStudentTicketDialog');
        },
        exportWord() {
            axios({
                url: `${home}/sysExamRoom/exportWord/${this.id}`,
                method: "GET",
                data: this.searchForm,
                responseType: "arraybuffer"
            }).then(res => {
                fileDownload(res, new Date().getFullYear()+"年湖北省普通高等学校专升本考试考生准考证.docx");
            });
        },
    }
}
</script>
<style lang="scss" scoped>
tr{
    height: 40px;
}
td{
    width: 80px;
}
th{
    width: 60px;
}
.titleTicket{
    width: 100%;height: 60px;line-height: 60px;
}
.titleSpan{
    color: #000;font-size: 18px;font-weight: bold
}
</style>
<style scoped lang="scss">
.xzitem{
    font-size: 15px;
    text-align: justify;
    text-justify:inter-ideograph;
    line-height: 22px;
}
.saveOrUpdateCrud{
    margin: 20px 0 0 10px;
}

.page {
    width: 21cm;
    min-height: 29.5cm;
    padding: 2cm;
    margin: auto;
    border-radius: 5px;
    background: white;
}


.pageStyle {
    float: left;
    height: 275px;
    width: 46%;
    margin-top: 45px;
    margin-left: 30px;
}
.schoolProcessList {
    margin-top: 20px;
    list-style: none;
    // height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    margin-left: -4%;
    // margin-top: -5%;
    // align-content: space-around;
    li {
        border-radius: 6px;
        background: #e8f1fb;
        margin-left: 4%;
        // margin-top: 5%;
        width: 12.6%;
        text-align: center;
        margin-bottom: 4%;
        img {
            margin: 12% auto 10%;
            width: 55%;
        }
        .oa-btn .el-button {
            min-width: 60%;
            max-width: 90%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-left: 5%;
            padding-right: 5%;
            margin-bottom: 18%;
            border-radius: 60px;
            padding-top: 4.5%;
            padding-bottom: 4.5%;

        }
    }
}

</style>
